// extracted by mini-css-extract-plugin
export var desktopOnly = "AsideColumnLayoutSlot-module--desktopOnly--e8ee7";
export var hidden = "AsideColumnLayoutSlot-module--hidden--53c5b";
export var hideOnTablet = "AsideColumnLayoutSlot-module--hideOnTablet--6cdd5";
export var position_bottom = "AsideColumnLayoutSlot-module--position_bottom--81898";
export var position_center = "AsideColumnLayoutSlot-module--position_center--1b52f";
export var position_top = "AsideColumnLayoutSlot-module--position_top--46837";
export var root = "AsideColumnLayoutSlot-module--root--e399e";